import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import sidebar from './sidebar';
import auth from './auth';
import intakeForm from './intakeForm';
import leads from './leads';
import lead from './lead';
import gmaps from './gmaps';
import modals from './modals';
import invites from './invites';
import proposals from './proposals';
import resources from './resources';
import agreements from './agreements';
import bulkEnrichment from './bulkEnrichment';
import prospectNowBulkEnrichment from './prospectNowBulkEnrichment';
import quotes from './quotes';

export default (history) =>
  combineReducers({
    router: connectRouter(history),
    sidebar,
    auth,
    intakeForm,
    leads,
    lead,
    gmaps,
    modals,
    invites,
    proposals,
    resources,
    agreements,
    bulkEnrichment,
    prospectNowBulkEnrichment,
    quotes,
  });
